import { ReactIntegration, getWebInstrumentations, initializeFaro } from '@grafana/faro-react'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { B3Propagator } from '@opentelemetry/propagator-b3'
import { useEffect } from 'react'
import {
  config,
  getServiceNameByAppName,
  getAppVersionByAppName,
  getAppEnvironmentByAppName,
  getEnvironmentsToMonitorByAppName,
  isValidEnvToMonitor,
} from './config'

export function FaroInjector() {
  useEffect(() => {
    const name = getServiceNameByAppName('studio-web')
    const version = getAppVersionByAppName('studio-web')
    const environment = getAppEnvironmentByAppName('studio-web')
    const enviromentsToMonitor = getEnvironmentsToMonitorByAppName('studio-web')
    const { faro: faroConfig } = config
    const { url, traceHeaders } = faroConfig

    if (!isValidEnvToMonitor(enviromentsToMonitor, environment)) {
      return
    }

    initializeFaro({
      url: url,
      app: {
        name,
        version,
        environment,
      },

      instrumentations: [
        ...getWebInstrumentations(),
        new ReactIntegration(),
        new TracingInstrumentation({
          propagator: new B3Propagator(),
          instrumentationOptions: {
            propagateTraceHeaderCorsUrls: traceHeaders ? traceHeaders.split(',').map((host) => new RegExp(host)) : [],
          },
        }),
      ],
    })
  }, [])

  return null
}
